import {createGlobalStyle} from "styled-components";
import {fontFamily} from "./font";

const GlobalStyles = createGlobalStyle`
   ${fontFamily};
`;

export {GlobalStyles};
